<template>
  <div class="hero">
    <v-img
      v-if="$vuetify.breakpoint.xsOnly"
      src="@/assets/bg-mobile.jpg"
      height="100%"
      width="100%"
      gradient="rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)"
    >
    </v-img>
    <video
      v-else
      class="bg-video"
      poster="@/assets/bg-image.jpg"
      autoplay
      muted
      loop
    >
      <source src="@/assets/bg-video.mp4" type="video/mp4" />
    </video>
    <div class="hero-title d-flex flex-column justify-end">
      <h1
        class="hero-title-text white--text text-uppercase font-weight-regular accent-text accent-text-section0-dark"
      >
        <span
          class="hero-title-text-lead"
          :class="$vuetify.breakpoint.xsOnly ? 'display-2' : 'display-4'"
          >{{ $t("content.title.lead") }}</span
        ><br />
        <span
          class="hero-title-text-body"
          :class="$vuetify.breakpoint.xsOnly ? 'display-1' : 'display-3'"
          >{{ $t("content.title.body") }}</span
        >
      </h1>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.hero {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.bg-video {
  z-index: -1;
  min-width: 100%;
  min-height: 100%;
}

.hero-title {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero-title::before {
  content: "";
  /* background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAG0lEQVQYV2NkYGD4z8DAwMgABXAGNgGwSgwVAFbmAgXQdISfAAAAAElFTkSuQmCC)
    repeat; */
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.hero-title-text {
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 15%;
  max-width: 780px;
}

.hero-title-text .hero-title-text-lead,
.hero-title-text .hero-title-text-body {
  letter-spacing: 0.01em !important;
  line-height: 1.3;
}
</style>